import { render, staticRenderFns } from "./strippay copy.vue?vue&type=template&id=6aae5b80&scoped=true"
import script from "./strippay copy.vue?vue&type=script&lang=js"
export * from "./strippay copy.vue?vue&type=script&lang=js"
import style0 from "./strippay copy.vue?vue&type=style&index=0&id=6aae5b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae5b80",
  null
  
)

export default component.exports